export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0008_MR1_3615_tn.1740e3b0.jpg";